<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>User Groups</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-2">
          <v-btn color="primary" small to="/new-user-group">
            <v-icon left dark>mdi-plus</v-icon>New User Group
          </v-btn>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6">
             <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="userGroups"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn icon :to="`/edit-user-group/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    pageItems: 100,
    headers: [
      { text: "Name", value: "name" },
      { text: "Edit", value: "action" },
    ],
    userGroups: [],
  }),
  methods: {
    getGroups() {
      const self = this;
      this.$store
        .dispatch("get", `/user-groups`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.userGroups = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGroups();
  },
};
</script>